// extracted by mini-css-extract-plugin
module.exports = {"tag":"DeskBookingForm_tag__1a0MG","selected":"DeskBookingForm_selected__326hF"};